document.addEventListener('DOMContentLoaded', function(){
    const swiperAbsolute = document.querySelectorAll('.swiper-absolute__transform');

    swiperAbsolute.forEach(swiperWrapper => {
        const swiper = swiperWrapper.querySelector('.swiper');

        swiperElement = new Swiper(swiper, {
            loop: true,
            speed: 4000,
            slidesPerView: 1,
            spaceBetween: 30,
            allowMouseEvents: false,
            direction: "horizontal",
            autoplay: {
                delay: 0
            },
            breakpoints: {
                768: {
                    direction: "vertical",
                    slidesPerView: 1
                },
                1420: {
                    direction: "vertical",
                    slidesPerView: 2
                }
            }
        });
    });
});